<template>
  <div id="permission">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'permission'
}
</script>




// WEBPACK FOOTER //
// src/views/system/permission/Permission.vue